const layer = {
    'is-background-layer': true,
    'id': 'luchtfoto-pdok',
    'type': 'raster',
    'source': 'luchtfoto-pdok',
    'layout': {
        'visibility': 'none' // Start hidden
    },
    'paint': {
        // "raster-opacity": 0
    },
}
  
export default layer;
